import axios from 'axios';

const api = axios.create({
  // baseURL: 'http://127.0.0.1:8888/api', // Point to the root of the 
  baseURL: 'https://erp-api.caojie666.xyz/api'
});

// Request interceptor to add the auth token to every request
api.interceptors.request.use(
  (config) => {
    const storedSession = localStorage.getItem('erp-session');
    
    if (storedSession) {
      try {
        const session = JSON.parse(storedSession);
        const token = session?.access_token;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (e) {
        console.error('Could not parse stored session.', e);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 Unauthorized errors
api.interceptors.response.use(
  (response) => {
    // If the response is successful, just return it
    return response;
  },
  (error) => {
    // If the error response is a 401, redirect to login
    if (error.response && error.response.status === 401) {
      // Clear the user session
      localStorage.removeItem('erp-session');
      // Redirect to the login page. Using window.location.href to force a full refresh.
      window.location.href = '/login';
    }
    
    // For other errors, just pass them along
    return Promise.reject(error);
  }
);

export default api;
